import {Column} from 'react-table'
import {ContractsProject} from './ContractsProject'
import {ContractsTypes} from './ContractsTypes'
import {ContractsActionsCell} from './ContractsActionsCell'
import {ContractsCustomHeader} from './ContractsCustomHeader'
import {Contracts} from '../../core/_models'
import {ContractsProperty} from './ContractsProperty'
import {ContractsIdentifier} from './ContractsIdentifier'
import {ContractsMeasuarement} from './ContractsMeasurement'
import {ContractsExpirationContract} from './ContractsExpirationContract'
import {ContractsStartContract} from './ContractsStartContract'
import {ContractsFields} from './ContractsFields'

const ContractsColumns: ReadonlyArray<Column<Contracts>> = [
  //HEADER COLUMN - PROJECT
  {
    Header: (props) => (
      <ContractsCustomHeader
        tableProps={props}
        title='PROJECT.PROJECT_TITLE'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'project',
    Cell: ({...props}) => <ContractsProject Contracts={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - Identificador ***
  {
    Header: (props) => (
      <ContractsCustomHeader
        tableProps={props}
        title='CONTRACTS.IDENTIFIER'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'identifier',
    Cell: ({...props}) => <ContractsIdentifier Contracts={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - PROPERTIES
  {
    Header: (props) => (
      <ContractsCustomHeader
        tableProps={props}
        title='PROPERTIES.TITLE'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'property',
    Cell: ({...props}) => <ContractsProperty Contracts={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - CONTRACT TYPE
  {
    Header: (props) => (
      <ContractsCustomHeader
        tableProps={props}
        title='CONTRACTS.TYPE'
        className='fs-8  text-center flex-row-fluid flex-center'
      />
    ),
    id: 'contract_type',
    Cell: ({...props}) => <ContractsTypes Contracts={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ISSUE DATE ***
  {
    Header: (props) => (
      <ContractsCustomHeader
        tableProps={props}
        title='CONTRACTS.MEASUREMENT'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'measurement',
    Cell: ({...props}) => <ContractsMeasuarement Contracts={props.data[props.row.index]} />,
  },

  //HEADER COLUMN -  limit_renovation ***
  {
    Header: (props) => (
      <ContractsCustomHeader
        tableProps={props}
        title='CONTRACTS.START_DATE'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'start_contract',
    Cell: ({...props}) => <ContractsStartContract Contracts={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - expiration_date ***
  {
    Header: (props) => (
      <ContractsCustomHeader
        tableProps={props}
        title='CONTRACTS.EXPIRATION_DATE'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'expiration_contract',
    Cell: ({...props}) => <ContractsExpirationContract Contracts={props.data[props.row.index]} />,
  },

  //HEADER COLUMN -  FIELDS ***
  {
    Header: (props) => (
      <ContractsCustomHeader
        tableProps={props}
        title='ENTERPRISES.INPUT_FIELDS'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'property.fields',
    Cell: ({...props}) => <ContractsFields Contracts={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ACTIONS
  {
    Header: (props) => (
      <ContractsCustomHeader tableProps={props} title='MENU.ACTIONS' className='fs-8 min-w-auto ' />
    ),
    id: 'actions',
    Cell: ({...props}) => <ContractsActionsCell data={props.data[props.row.index]} />,
  },
]

export {ContractsColumns}
